const fullName = ({ firstName, lastName }) => `${firstName || ''} ${lastName || ''}`.trim();

export const fullNamePartner = ({ partnerFirstName, partnerLastName }) => `${partnerFirstName || ''} ${partnerLastName || ''}`.trim();

export const afficheNomPrenom = (prenom, nom) => {
    if (!prenom && !nom) {
        return '';
    }

    return fullName({ firstName: prenom, lastName: nom });
};

export const invertedFullName = ({ firstName, lastName }) =>
    `${lastName || ''} ${firstName || ''}`.trim();

export default fullName;
